import i18n from "@/i18n";

// Homepage templates
const blogsPrimaryHomepage = require(`../assets/images/template_previews/blogs_primary.png`);
const blogsGreenHomepage = require(`../assets/images/template_previews/blogs_green.png`);
const blogsPurpleHomepage = require(`../assets/images/template_previews/blogs_purple.png`);
const blogsLightBlueHomepage = require(`../assets/images/template_previews/blogs_light_blue.png`);
const blogsBlackHomepage = require(`../assets/images/template_previews/blogs_black.png`);
const blogsNavyBlueHomepage = require(`../assets/images/template_previews/blogs_navy_blue.png`);
const blogsDarkBlueHomepage = require(`../assets/images/template_previews/blogs_dark_blue.png`);
const blogsDollarGreenHomepage = require(`../assets/images/template_previews/blogs_dollar_green.png`);
const blogsPlumPurpleHomepage = require(`../assets/images/template_previews/blogs_plum_purple.png`);
const blogsMutedAmberHomepage = require(`../assets/images/template_previews/blogs_muted_amber.png`);

export const dataImageSizes = {
  xs: "300w",
  sm: "480w",
  md: "768w",
  lg: "1024w",
};

export const ROLE_ADMIN = {
  value: "ROLE_ADMIN",
  title: "Administrator",
  title_shorthand: "Admin",
  icon: "mdi-shield-account-variant",
  disclaimer: i18n.t("settings.workplace_users_invite_role_admin_disclaimer"),
};

export const ROLE_EDITOR = {
  value: "ROLE_EDITOR",
  title: "Editor",
  title_shorthand: "Editor",
  icon: "mdi-pencil",
  disclaimer: i18n.t("settings.workplace_users_invite_role_editor_disclaimer"),
};

export const ROLE_BASIC = {
  value: "ROLE_BASIC",
  title: "Basic",
  title_shorthand: "Basic",
  icon: "mdi-shield-account-variant",
};

export const ROLE_OWNER = {
  value: "ROLE_OWNER",
  title: "Owner",
  title_shorthand: "Owner",
  icon: "mdi-account-key",
};

export const ROLE_SUPPORT = {
  value: "ROLE_SUPPORT",
};

export const USER_ROLES = [ROLE_ADMIN, ROLE_EDITOR, ROLE_OWNER, ROLE_BASIC];

// TODO: Might be useful later
export const USER_ROLE_FALLBACK = {
  icon: "mdi-tag",
  information: "This field is for explanation of the role (could be stored in some info about roles)",
};

export const LIVE_CHAT_DEFAULT_QUESTIONS = [
  { text: "Enter your ZIP code", value: "zip" },
  { text: "Who is your current insurer?", value: "current_insurer" },
  { text: "Do you want to insure multiple vehicles?", value: "multiple_vehicles" },
  { text: "Which age group are you in?", value: "age_group" },
  { text: "Do you own your home?", value: "home_ownership" },
  { text: "Do you have a DUI?", value: "dui" },
  { text: "How long have you been continuously insured?", value: "continuously_insured" },
  { text: "How many incidents have you had in the last 12 months?", value: "incidents" },
  { text: "Do you need an SR-22 form?", value: "sr_22_form" },
  { text: "Are you insured?", value: "is_insured" },
];

export const FONT_FAMILIES = [
  { text: "Poppins", value: "Poppins, sans-serif" },
  { text: "Arial", value: "Arial, Helvetica, sans-serif" },
  { text: "Georgia", value: "Georgia, serif" },
  { text: "Verdana", value: "Verdana, Geneva, sans-serif" },
  { text: "Tahoma", value: "Tahoma, sans-serif" },
  { text: "Helvetica", value: "Helvetica, sans-serif" },
  { text: "Open Sans", value: "Open Sans, Helvetica, sans-serif" },
  { text: "Roboto", value: "Roboto, Helvetica, sans-serif" },
  { text: "Source Sans Pro", value: "Source Sans Pro, Helvetica, sans-serif" },
  { text: "Lato", value: "Lato, Helvetica, sans-serif" },
  { text: "Atkinson Hyperlegible", value: "Atkinson Hyperlegible, sans-serif" },
];

export const LIVE_CHAT_CTA_V2_FONT_FAMILIES = FONT_FAMILIES;

export const LIVE_CHAT_CTA_V2_FONT_SIZES = [
  "8px",
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "19px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
  "30px",
  "32px",
  "34px",
  "36px",
  "40px",
].map(size => ({ text: size, value: size }));

export const HEADERS_TEMPLATES_UPDATES_DATE = "2023-07-06T07:59:29+00:00";

// Blog header template values
export const HEADER_BLOG_TEMPLATES = {
  BLOGS: "blogs",
  BLOGS_GREEN: "blogs_green",
  BLOGS_DOLLAR_GREEN: "blogs_dollar_green",
  BLOGS_LIGHT_BLUE: "blogs_light_blue",
  BLOGS_NAVY_BLUE: "blogs_navy_blue",
  BLOGS_DARK_BLUE: "blogs_dark_blue",
  BLOGS_BLACK: "blogs_black",
  BLOGS_PLUM_PURPLE: "blogs_plum_purple",
  BLOGS_MUTED_AMBER: "blogs_muted_amber",
};

export const HEADER_BLOG_TEMPLATES_VALUES = Object.values(HEADER_BLOG_TEMPLATES);

export const HEADER_CONTENT_ONLY_TEMPLATE = "content_only";

export const HEADER_LOGO_LEFT_BURGER_TEMPLATE = "logo_left_burger";

export const HEADER_TEMPLATES = [
  { text: "Logo left + Content", value: "logo_left_content" },
  { text: "Logo center + Content", value: "logo_center_content" },
  { text: "Content only", value: HEADER_CONTENT_ONLY_TEMPLATE },
  { text: "Blogs", value: HEADER_BLOG_TEMPLATES.BLOGS },
  { text: "Blogs Green", value: HEADER_BLOG_TEMPLATES.BLOGS_GREEN },
  { text: "Dollar Green", value: HEADER_BLOG_TEMPLATES.BLOGS_DOLLAR_GREEN },
  { text: "Blogs Light blue", value: HEADER_BLOG_TEMPLATES.BLOGS_LIGHT_BLUE },
  { text: "Blogs Navy blue", value: HEADER_BLOG_TEMPLATES.BLOGS_NAVY_BLUE },
  { text: "Blogs Dark blue", value: HEADER_BLOG_TEMPLATES.BLOGS_DARK_BLUE },
  { text: "Blogs Black", value: HEADER_BLOG_TEMPLATES.BLOGS_BLACK },
  { text: "Plum Purple", value: HEADER_BLOG_TEMPLATES.BLOGS_PLUM_PURPLE },
  { text: "Muted Amber", value: HEADER_BLOG_TEMPLATES.BLOGS_MUTED_AMBER },
];
export const HEADER_TEMPLATES_OLD = [
  { text: "Default (Old)", value: "default" },
  { text: "Mobile Burger (Old)", value: "mobile_burger" },
  { text: "Centred logo (Old)", value: "centred_logo" },
];

export const HEADER_MOBILE_TEMPLATES = [
  { text: "Logo left + Content", value: "logo_left_content" },
  { text: "Logo center + Content", value: "logo_center_content" },
  { text: "Content only", value: HEADER_CONTENT_ONLY_TEMPLATE },
  { text: "Logo left + Menu burger icon (with link)", value: HEADER_LOGO_LEFT_BURGER_TEMPLATE },
  { text: "Logo center", value: "logo_center" },
];

export const LIVE_CHAT_HEADER_TEMPLATES = [
  { text: "iMessage", value: "imessage" },
  { text: "Messenger", value: "messenger" },
];

export const HEADER_LOGO_POSITIONS = [
  { text: "Left (Old)", value: 1 },
  { text: "Center (Old)", value: 2 },
];
export const AB_REDIRECT_TYPES = {
  REPLACE: "replace",
  HREF: "href",
};

export const AB_POOL_TYPES = {
  GENERAL: "general",
  STATE: "state",
};
export const AB_SPLIT_TYPES = {
  CUSTOM: "custom",
  EVEN: "even",
};
export const AB_REDIRECT_METHODS = [
  { text: "Non-History Redirect", value: AB_REDIRECT_TYPES.REPLACE },
  { text: "History Redirect", value: AB_REDIRECT_TYPES.HREF },
];
export const FOOTER_TEMPLATES = [
  { text: "Default", value: "default" },
  { text: "Blogs", value: "blogs" },
  { text: "Blogs purple", value: "blogs_purple" },
  { text: "Blogs green", value: "blogs_green" },
  { text: "Dollar Green", value: "blogs_dollar_green" },
  { text: "Audio forms", value: "audio_forms" },
  { text: "Blogs Light blue", value: "blogs_light_blue" },
  { text: "Blogs Navy blue", value: "blogs_navy_blue" },
  { text: "Blogs Dark blue", value: "blogs_dark_blue" },
  { text: "Blogs Black", value: "blogs_black" },
  { text: "Plum Purple", value: "blogs_plum_purple" },
  { text: "Muted Amber", value: "blogs_muted_amber" },
];

export const FOOTER_MENU_POSITIONS = [
  { text: "Left", value: 1 },
  { text: "Center", value: 2 },
];

export const FOOTER_MENU_ITEM_FONT_SIZES = [
  { text: "8px", value: "8px" },
  { text: "9px", value: "9px" },
  { text: "10px", value: "10px" },
  { text: "11px", value: "11px" },
  { text: "12px", value: "12px" },
  { text: "13px", value: "13px" },
  { text: "14px", value: "14px" },
  { text: "15px", value: "15px" },
  { text: "16px", value: "16px" },
  { text: "17px", value: "17px" },
  { text: "18px", value: "18px" },
  { text: "19px", value: "19px" },
  { text: "20px", value: "20px" },
  { text: "21px", value: "21px" },
  { text: "22px", value: "22px" },
  { text: "23px", value: "23px" },
  { text: "24px", value: "24px" },
  { text: "25px", value: "25px" },
  { text: "26px", value: "26px" },
];

export const FOOTER_LOGO_POSITIONS = [
  { text: "Left", value: 1 },
  { text: "Center", value: 2 },
  { text: "Right", value: 3 },
];

export const DOMAIN_STATUS = {
  CONNECTED: "connected",
  CONNECTING: "connecting",
  ERROR: "error",
};

export const DOMAIN_DEPLOYMENT_STATUS = [
  { status: DOMAIN_STATUS.CONNECTING, label: "Configuring...", chipColor: "" },
  { status: DOMAIN_STATUS.CONNECTED, label: "Connected", chipColor: "success" },
  { status: DOMAIN_STATUS.ERROR, label: "Error", chipColor: "error" },
];

export const DOMAIN_TYPE = {
  PROVIDED: "provided",
  CUSTOM: "custom",
};

export const ROBOTS = {
  allow: "User-agent: *\nAllow: /",
  disallow: "User-agent: *\nDisallow: /",
};

export const DOMAIN_SUSPENSION_REASONS = [
  { value: "circumventing", text: "Circumventing" },
  { value: "circumventing_cloaking", text: "Circumventing: Cloaking" },
  { value: "ubp", text: "UBP" },
  { value: "ubp_public_figure", text: "UBP: Public Figure" },
];

export const NAMECHEAP_DOMAIN_CONTROL_PANEL_URL = "https://ap.www.namecheap.com/domains/domaincontrolpanel";

export const BLOGS_TEMPLATES = [
  {
    label: "Blogs Primary",
    value: "blogs_primary",
    image: blogsPrimaryHomepage,
  },
  {
    label: "Blogs green",
    value: "blogs_green",
    image: blogsGreenHomepage,
  },
  {
    label: "Dollar Green",
    value: "blogs_dollar_green",
    image: blogsDollarGreenHomepage,
  },
  {
    label: "Blogs purple",
    value: "blogs_purple",
    image: blogsPurpleHomepage,
  },
  {
    label: "Blogs Light blue",
    value: "blogs_light_blue",
    image: blogsLightBlueHomepage,
  },
  {
    label: "Blogs Navy blue",
    value: "blogs_navy_blue",
    image: blogsNavyBlueHomepage,
  },
  {
    label: "Blogs Dark blue",
    value: "blogs_dark_blue",
    image: blogsDarkBlueHomepage,
  },
  {
    label: "Blogs Black",
    value: "blogs_black",
    image: blogsBlackHomepage,
  },
  {
    label: "Plum Purple",
    value: "blogs_plum_purple",
    image: blogsPlumPurpleHomepage,
  },
  {
    label: "Muted Amber",
    value: "blogs_muted_amber",
    image: blogsMutedAmberHomepage,
  },
];

export const PAGE_TYPE = {
  LANDER: 1,
  ARTICLE: 2,
  AUDIO_FORM: 3,
  LEGAL: 4,
};

export const PAGE_TYPES = [
  { text: "Lander", value: PAGE_TYPE.LANDER },
  { text: "Article", value: PAGE_TYPE.ARTICLE },
  { text: "Audio form", value: PAGE_TYPE.AUDIO_FORM },
  { text: "Legal", value: PAGE_TYPE.LEGAL },
];

export const SECTION_DEFAULT_TITLE = "Section Title";

export const BACKGROUND_PROPERTIES = [
  { text: "Repeat", value: "repeat" },
  { text: "Fixed", value: "fixed" },
];

export const ADVANCED_CONTENT_SEARCH = [
  {
    value: "",
    text: i18n.t("resources.pages.content_search_filters.basic_search"),
  },
  {
    value: "content",
    text: i18n.t("resources.pages.content_search_filters.advanced_search"),
  },
  {
    value: "encoded_content",
    text: i18n.t("resources.pages.content_search_filters.encoded_content_search"),
  },
];

export const TOAST_INITIAL_TIME = "10000";

export const PAGE_STATUS_DRAFT = 1;
export const PAGE_STATUS_PUBLISHED = 2;
export const PAGE_STATUS_ARCHIVED = 3;

export const PAGE_STATUSES = [
  { text: "Draft", value: PAGE_STATUS_DRAFT, chipColor: null, tooltipText: i18n.t("resources.pages.draft_tooltip") },
  {
    text: "Published",
    value: PAGE_STATUS_PUBLISHED,
    chipColor: "success",
    tooltipText: i18n.t("resources.pages.published_tooltip"),
  },
  { text: "Archived", value: PAGE_STATUS_ARCHIVED, chipColor: "archived" },
];
export const SUCCESS_FILTERS = [
  { text: "Success", value: true },
  { text: "Failure", value: false },
];
export const RINGBA_FILTERS = [
  {
    label: "Phone number",
    options: [{ text: "No number", value: "no_number" }],
  },
  {
    label: "RINGBA CODE/TAG",
    options: [
      { text: "No code", value: "no_script" },
      { text: "Script", value: "script" },
      { text: "Wrapper", value: "worker" },
    ],
  },
];

export const MENU_ITEM_TYPES = [
  { text: "Page", value: 1 },
  { text: "Link", value: 2 },
  { text: "Page Category", value: 3 },
];

export const FEATURED_CATEGORIES_ITEM_TYPES = [
  { text: "Link", value: "link" },
  { text: "Page Category", value: "page_category" },
];

export const MENU_TAB_TYPES = [
  { text: "Same tab", value: "same_tab" },
  { text: "New tab", value: "new_tab" },
];

export const MODAL_DISPLAY_TYPES = [
  { text: "Inactivity (after 20s)", value: 1 },
  { text: "Back", value: 2 },
  { text: "Exit", value: 3 },
  { text: "Congratulations", value: 4 },
];

export const USER_STATUSES = {
  REGISTERED: "registered",
  PARTIALLY_REGISTERED: "partially_registered",
};

export const USER_DELETE_CONFIRMATION_WORD = "DELETE";

export const ORGANIZATION_DELETE_CONFIRMATION_WORD = "DELETE";

export const LIST_ITEMS_PER_PAGE = [5, 10, 15, 20, 50];
export const DOMAIN_PARAMETER_QUERY_KEY = "sessid";

/**
 * Price in $ monthy
 */
export const PAYMENT_PLANS = {
  BASIC: {
    name: "Basic",
    code: "SR-BASIC",
    price: 7.95,
    teammatesLimit: 1,
    formattedTeammatesLimit: "1",
    domainsLimit: 1,
    formattedDomainsLimit: "1",
    uniqueBenefit: "1-on-1 onboarding call",
    additionalChip: {
      text: "Personalized offer",
      textColor: "#FF8A00",
      color: "#ffb4001c",
    },
  },
  STANDARD: {
    name: "Standard",
    code: "SR-STANDARD",
    price: 49,
    teammatesLimit: 1,
    formattedTeammatesLimit: "1",
    domainsLimit: 1,
    formattedDomainsLimit: "1",
    uniqueBenefit: "Customer support (email, chat)",
  },
  PRO: {
    name: "Pro",
    code: "SR-PRO",
    price: 99,
    teammatesLimit: 3,
    formattedTeammatesLimit: "3",
    domainsLimit: 10,
    formattedDomainsLimit: "10",
    uniqueBenefit: "24/7 priority tech support",
  },
  AGENCY: {
    name: "Agency",
    code: "SR-AGENCY",
    price: 299,
    teammatesLimit: 9999,
    formattedTeammatesLimit: "Unlimited",
    domainsLimit: 9999,
    formattedDomainsLimit: "Unlimited",
    uniqueBenefit: "24/7 priority tech support",
  },
};

export const PAYMENT_DISCOUNTS = {
  // TODO: update discounts once/if we enable marketing pages
  // STANDARD_30: {
  //   discountLabel: "30% OFF",
  //   // Amount in $, not percentage. Subtracted from the Plan.price
  //   discountAmount: 50,
  //   appliesTo: [PAYMENT_PLANS.STANDARD.name],
  //   couponCode: "STANDARD30",
  // },
};

export const SUBSCRIPTION_STATUS = {
  INCOMPLETE: "incomplete",
  INCOMPLETE_EXPIRED: "incomplete_expired",
  TRIALING: "trialing",
  ACTIVE: "active",
  PAST_DUE: "past_due",
  CANCELED: "canceled",
  UNPAID: "unpaid",
  PAUSED: "paused",
  EARLY_ACCESS: "early_access",
};

export const INVOICE_STATUS = {
  DRAFT: "draft",
  OPEN: "open",
  PAID: "paid",
  UNCOLLECTIBLE: "uncollectible",
  VOID: "void",
};

export const MAIN_DOMAIN_URL = process.env.VUE_APP_PAGES_DOMAIN;

export const REGISTRAR_LIST = [
  {
    name: "NameCheap",
    value: "nameCheap",
    helpLink: "https://help.siterunner.com/help/domains-how-to-set-up-the-cname-records-for-namecheap",
  },
  {
    name: "Google Domains (SquareSpace)",
    value: "googleDomains",
    helpLink: "https://help.siterunner.com/help/domains-cname-records-for-google-domains-now-squarespace",
  },
  {
    name: "GoDaddy",
    value: "goDaddy",
    helpLink: "https://help.siterunner.com/help/domains-how-to-set-up-the-cname-records-for-godaddy",
  },
  {
    name: "BlueHost",
    value: "blueHost",
    helpLink: "https://help.siterunner.com/help/domains-how-to-set-up-the-cname-records-for-dreamhost",
  },
  {
    name: "DreamHost",
    value: "dreamHost",
    helpLink: "https://help.siterunner.com/help/domains-how-to-set-up-the-cname-records-for-dreamhost",
  },
  {
    name: "Other",
    value: "other",
    helpLink: "https://help.siterunner.com/help/search?keyword=cname",
  },
];

export const AB_SCRIPT = id => {
  return `<script>(()=>{const t="${id}",e="opacity: 0 !important; background: none !important;",r=document.documentElement.style;r.cssText+=e;const n=document.createElement("script");n.src=\`https://progress.siterunner.com/app.js?id=\${t}\${(()=>{try{const e=JSON.parse(localStorage.getItem("siterunner-progress"))[t];return void 0===e.e||Date.now()>e.e||void 0===e.t?"":\`&p=\${window.btoa(e.t)}\`}catch{return""}})()}\`,n.type="text/javascript",n.onerror=()=>{r.cssText=r.cssText.replace(e,"")},n.fetchPriority="high",document.head.prepend(n)})();</script>`;
};

export const GTM_FILTERS = [
  { text: "Added", value: "true" },
  { text: "Not added", value: "false" },
];

export const JOURNAYA_FILTERS = [
  { text: "Added", value: "true" },
  { text: "Not added", value: "false" },
];

export const LEADSPEDIA_FILTERS = [
  { text: "Added", value: "true" },
  { text: "Not added", value: "false" },
];

export const FORM_TYPE_FILTERS = [
  { text: "Auto", value: "auto" },
  { text: "Health", value: "health" },
  { text: "Med", value: "med" },
  { text: "Solar", value: "solar" },
];

export const AB_TEST_STATUSES = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  DRAFT: "draft",
};

export const AB_TEST_UNKNOWN_DATA = "Unknown";

export const AB_TEST_OUTCOMES = {
  WIN: "win",
  LOSS: "loss",
  NEED_DATA: "need_data",
  INCONCLUSIVE: "inconclusive",
};

export const AB_TEST_STATISTICS_OPTIONS = {
  SUMMARY: "summary",
  DAILY: "daily",
};

export const PAGE_HISTORY_STATUS = {
  UNKNOWN: "Unknown",
};

export const PAGE_UPLOAD_STATUSES = {
  SUCCESS: "Success",
  ERROR: "Error",
  PENDING: "Pending",
};

export const PHONE_NUMBER_STATUSES = {
  GENERATING: "generating",
  ACTIVE: "active",
  ERROR: "error",
};

export const PHONE_NUMBER = {
  campaignId: "",
  publisherSubId: "",
  publisherName: "",
  numberPoolId: "",
  domain: "",
  tollFree: false,
  tollFreeAreaCode: null,
};

export const PHONE_NUMBER_PROVIDERS = {
  RINGBA: "ringba",
  CALLSRUNNER: "callsrunner",
};

export const PHONE_NUMBER_PROVIDER_LABELS = {
  [PHONE_NUMBER_PROVIDERS.CALLSRUNNER]: "CallsRunner",
  [PHONE_NUMBER_PROVIDERS.RINGBA]: "Ringba",
};

export const PHONE_NUMBER_COUNTRIES = [
  { text: "US", value: "US" },
  { text: "CA", value: "CA" },
];

export const PHONE_NUMBER_TYPES = {
  LOCAL: "local",
  TOLL_FREE: "toll_free",
};

export const PHONE_NUMBER_CARRIERS = [
  { text: "Telnyx", value: "telnyx" },
  { text: "Twilio", value: "twilio" },
];

export const CALLSRUNNER_PHONE_NUMBER = {
  campaignName: "",
  publisherSubId: "",
  publisherName: "",
  numberPoolName: "",
  countryCode: "",
  domain: "",
  type: PHONE_NUMBER_TYPES.LOCAL,
  carrier: "telnyx",
  prefix: null,
};

export const VARIABLE_TYPES = {
  PHONE_NUMBER: "phone_number",
  PHONE_NUMBER_OLD: "phone_number_old",
};

export const AGE_INPUT_EVENT_TYPES = {
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
  UPDATE_AGE_INPUT_DATA: "updateAgeInputData",
  VALIDATION: "validation",
  REQUEST_DATA: "requestData",
};

export const SPIN_WHEEL_EVENT_TYPES = {
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
  UPDATE_SPIN_WHEEL_DATA: "updateSpinWheelData",
  VALIDATION: "validation",
  REQUEST_DATA: "requestData",
};

export const LIVE_CLAIM_FEED_EVENT_TYPES = {
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
  UPDATE_LIVE_CLAIM_FEED_DATA: "updateLiveClaimFeedData",
  VALIDATION: "validation",
  REQUEST_DATA: "requestData",
};

export const DYNAMIC_BUTTONS_EVENT_TYPES = {
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
  UPDATE_DYNAMIC_BUTTONS_DATA: "updateDynamicButtonsData",
  VALIDATION: "validation",
  REQUEST_DATA: "requestData",
};

export const NUMBERED_STEPS_EVENT_TYPES = {
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
  UPDATE_NUMBERED_STEPS_DATA: "updateNumberedStepsData",
  VALIDATION: "validation",
  REQUEST_DATA: "requestData",
};

export const NEWSLETTER_BANNER_EVENT_TYPES = {
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
  UPDATE_NEWSLETTER_BANNER_DATA: "updateNewsletterBannerData",
  VALIDATION: "validation",
  REQUEST_DATA: "requestData",
};

export const LIVE_CHAT_CTA_V2_EVENT_TYPES = {
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
  UPDATE_LIVE_CHAT_CTA_V2_DATA: "updateLiveChatCtaV2Data",
  VALIDATION: "validation",
  REQUEST_DATA: "requestData",
};

export const SOCIAL_PROOF_V2_EVENT_TYPES = {
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
  UPDATE_SOCIAL_PROOF_DATA: "updateSocialProofData",
  VALIDATION: "validation",
  REQUEST_DATA: "requestData",
};

export const CONTENT_BOX_EVENT_TYPES = {
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
  UPDATE_CONTENT_BOX_DATA: "updateContentBoxData",
  VALIDATION: "validation",
  REQUEST_DATA: "requestData",
};

export const CONTENT_BOX_BORDER_STYLES = ["none", "solid", "dashed", "dotted"];

export const CONTENT_BOX_BORDER_SIDES = ["top", "right", "bottom", "left"];

export const DEFAULT_CONTENT_BOX_BORDER_WIDTH = 3;

export const DEFAULT_CONTENT_BOX_BORDER_COLOR = "#2454C7";

export const DEFAULT_CONTENT_BOX_MARGIN = 18;

export const DEFAULT_CONTENT_BOX_MARGIN_BOX = {
  top: DEFAULT_CONTENT_BOX_MARGIN,
  right: 0,
  bottom: DEFAULT_CONTENT_BOX_MARGIN,
  left: 0,
};

export const DEFAULT_CONTENT_BOX_PADDING = { top: 20, right: 24, bottom: 22, left: 24 };

export const DEFAULT_CONTENT_BOX_LINE_LENGTH = 100;

export const TEXT_UNDERLINE_EVENT_TYPES = {
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
  UPDATE_TEXT_UNDERLINE_DATA: "updateTextUnderlineData",
  VALIDATION: "validation",
  REQUEST_DATA: "requestData",
};

export const CUSTOM_BUTTON_EVENT_TYPES = {
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
  UPDATE_DATA: "updateCustomButtonData",
  VALIDATION: "validation",
  REQUEST_DATA: "requestData",
};

// Random data arrays for Live Claim Feed
export const LIVE_CLAIM_FEED_FIRST_NAMES = [
  "Elena",
  "Keiko",
  "Meera",
  "Aisha",
  "James",
  "Maria",
  "Carlos",
  "Liam",
  "Sophia",
  "Noah",
  "Olivia",
  "Mason",
  "Ava",
  "Ethan",
  "Grace",
  "Leo",
  "Maya",
  "Ivy",
  "Jonah",
];

export const LIVE_CLAIM_FEED_LAST_INITIALS = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "J",
  "K",
  "L",
  "M",
  "N",
  "P",
  "R",
  "S",
  "T",
  "V",
];

export const LIVE_CLAIM_FEED_STATES = [
  "KY",
  "CO",
  "AK",
  "SC",
  "TX",
  "FL",
  "CA",
  "NY",
  "GA",
  "IL",
  "WA",
  "MI",
  "NC",
  "VA",
  "AZ",
  "NJ",
  "PA",
  "OH",
  "OR",
  "MA",
];
